
export default {
  productData: {
    serialNumber: 'DA-HOU-001',
    name: 'Holzbalkendecken ohne Unterdecken | Aufbau 1',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 50',
          value: 'w-50'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolledämmplatte MW<br>(<i>s‘</i> ≤ 6 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 40',
          value: 'm-40'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung, Rieselschutz' },
          output: '≥ 30',
          value: 'scsb-30'
        },
        {
          type: 'woodenPanel',
          title: { de: 'Holzwerkstoffplatte HW' },
          output: '25',
          value: 25
        },
        {
          type: 'supportingStructure',
          title: { de: 'Balken' },
          output: '220',
          value: 'b-220'
        }
      ],
      sum: {
        output: '362', value: 362
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '50 (-2)', value: 50
      },
      soundReductionIndex: { // Rw
        output: '67 (-2; -6)', value: 67
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,56', value: 0.56
      },
      fireResistance: {
        output: '-', value: null
      },
      massPerUnitArea: {
        output: '198,2 [kg/m²]'
      }
    }
  },
  image: 'da-hou-001.png',
  pdf: 'Holzbalkendecken-ohne-Unteredecke-Aufbau-1-DA-HOU-001-Rev04.pdf'
}
